export const linkdatas = [
	{ id: 1, title: 'Match', link: '/matches' },
	{ id: 2, title: 'Competition', link: '/competitions' },
	{ id: 3, title: 'Teams', link: '/teams' },
	{ id: 4, title: 'Players', link: '/players' },
];
